import { InputLabel, MenuItem, styled } from "@mui/material";

export const BybInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.dsBase.v200,
  opacity: 0.4,
  ...theme.typography.text1xl500,
  transform: "translate(16px, 15px)",
}));

export const BybMenuItem = styled(MenuItem)(({ theme }) => ({
  ...theme.typography.textBase500,
  color: theme.palette.dsBase.v200,
  "&:hover": {
    backgroundColor: theme.palette.dsBase.v100,
  },
}));
